var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.246,6.193v0a6.744,6.744,0,0,0,1.737-3.94A2,2,0,0,0,16.749.016,6.318,6.318,0,0,0,12.133,2.6,8.162,8.162,0,0,0,10.711.271a1,1,0,0,0-1.428,1.4A7.583,7.583,0,0,1,10.942,6H8.5A8.771,8.771,0,0,0,0,15c-.161,5.6,5.644,10.773,10.75,8.385a2.4,2.4,0,0,1,2.605.019A4.444,4.444,0,0,0,15.5,24C25.764,23.716,27.066,8.582,17.246,6.193ZM14.223,3.168A4.783,4.783,0,0,1,17,2v0a4.8,4.8,0,0,1-1.167,2.772,4.793,4.793,0,0,1-2.778,1.168A4.785,4.785,0,0,1,14.223,3.168ZM15.5,22a2.542,2.542,0,0,1-1.244-.381A4.62,4.62,0,0,0,12,21a4.527,4.527,0,0,0-2.137.593C6.005,23.261,1.9,19.141,2,15A6.772,6.772,0,0,1,8.5,8h7C24.1,8.321,24.1,21.682,15.5,22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrApple);
export default __webpack_public_path__ + "static/media/fi-rr-apple.ba43aaed.svg";
export { ForwardRef as ReactComponent };